import LandingShell from "./LandingShell";
import Layout2Operations from "./layouts/Layout2Operations";
import Layout3Editorial from "./layouts/Layout3Editorial";
import EasyLanding from "./easy/EasyLanding";
import { useSiteConfig } from "../context/SiteConfigContext";

const SHELLS = {
    classic: LandingShell,
    operations: Layout2Operations,
    editorial: Layout3Editorial,
    easy: EasyLanding,
};

// Renders the admin-selected site-wide layout. All shells share the same
// {header, rightSlot} contract so the right slot keeps holding the guest auth
// card OR the logged-in live jobs map regardless of the chosen layout.
export default function SiteLayout({ header, rightSlot }) {
    const { layout } = useSiteConfig();
    const Shell = SHELLS[layout] || LandingShell;
    return <Shell header={header} rightSlot={rightSlot} />;
}
